import React, { useRef } from "react";
import {
  ProjectElementType,
  resource,
  status,
  WorkLoadsCalendar,
} from "@planzone/dto";

import { ElementTypes } from "@common/elementCreationForm/types";
import { Props } from "./types";
import { Task } from "../task";
import { Event } from "../event";
import { Milestone } from "../milestone";
import { List } from "../list";
import styles from "./styles.scss";

function QuickElementLoader({ type, name, parentList }: Props) {
  const dummyRef = useRef<HTMLDivElement>(null);
  const projectElement = {
    uuid: "",
    parentUuid: "",
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    completionDate: "",
    percentComplete: 0,
    depth: 0,
    keyRank: 0,
    referenceKeyRank: 0,
    tags: [],
    parentUuids: [],
    activityRootUuid: "",
    attributes: {},
  };
  const meta = {
    uuid: "",
    allocatedHours: 0,
    attachmentCount: 0,
    commentCount: 0,
    elementCount: 0,
    duration: 0,
    percentComplete: 0,
    spentHours: 0,
  };
  const workLoad: WorkLoadsCalendar[number] = {
    uuid: "",
    resourceName: "",
    resourceRoleName: "",
    resourceTitle: null,
    resourceType: "",
    resourceTags: [],
    totalOfEstimatedHours: 0,
    totalOfAllocatedHours: 0,
    totalOfSpentTime: 0,
    totalOfRemainingTime: 0,
    days: [],
    weeks: [],
    months: [],
  };

  return (
    <div
      className={styles.quickElementLoader}
      onClick={(e) => e.stopPropagation()}
    >
      {type === ElementTypes.LIST ? (
        <List
          list={{
            ...projectElement,
            name,
            type: ProjectElementType.LIST,
          }}
          workLoad={workLoad}
          meta={meta}
          parentList={parentList}
          toggle={() => {}}
          addIn={() => {}}
          addAfter={() => {}}
          isOpen
        />
      ) : type === ElementTypes.TASK ? (
        <Task
          task={{
            ...projectElement,
            name,
            type: ProjectElementType.TASK,
            allocations: [],
            status: { ...status, uuid: "" },
          }}
          meta={meta}
          parentList={parentList}
          resource={{ ...resource, uuid: "" }}
        />
      ) : type === ElementTypes.MILESTONE ? (
        <Milestone
          milestone={{
            ...projectElement,
            name,
            state: "TODO",
            type: ProjectElementType.MILESTONE,
          }}
          meta={meta}
        />
      ) : type === ElementTypes.EVENT ? (
        <Event
          event={{
            ...projectElement,
            name,
            type: ProjectElementType.EVENT,
          }}
          meta={meta}
          parentList={parentList}
        />
      ) : (
        <React.Fragment />
      )}
    </div>
  );
}

export { QuickElementLoader };
